module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1directdaughtercrossingmode"
    }
  }, [_vm._v("CHAPTER 1 - DIRECT DAUGHTER CROSSING MODE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2holdagoodhandofcards"
    }
  }, [_vm._v("CHAPTER 2 - HOLD A GOOD HAND OF CARDS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3yethehadactuallycausedhimselftocommitsuicide"
    }
  }, [_vm._v("CHAPTER 3 - YET, HE HAD ACTUALLY CAUSED HIMSELF TO COMMIT SUICIDE …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4myriadlovecollection"
    }
  }, [_vm._v("CHAPTER 4 - MYRIAD LOVE COLLECTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5collapseoftheconceptofmarriage"
    }
  }, [_vm._v("CHAPTER 5 - COLLAPSE OF THE CONCEPT OF MARRIAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6princessaccompanyingreading"
    }
  }, [_vm._v("CHAPTER 6 - PRINCESS ACCOMPANYING READING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7astonestirsathousandripples"
    }
  }, [_vm._v("CHAPTER 7 - A STONE STIRS A THOUSAND RIPPLES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8preparingforentrytothepalace"
    }
  }, [_vm._v("CHAPTER 8 - PREPARING FOR ENTRY TO THE PALACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/8_chapter9oldmasterxuaskedhimtoreturnhomeinadream"
    }
  }, [_vm._v("CHAPTER 9 - OLD MASTER XU ASKED HIM TO RETURN HOME IN A DREAM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10ladyjiwantsabutler1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - LADY JI WANTS A BUTLER (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11ladyjiwantsabutler2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - LADY JI WANTS A BUTLER (2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12xumingmeiavoidedthemoonnesting1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - XU MINGMEI AVOIDED THE MOON-NESTING (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13xumingmeiavoidedthemoonnestingpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - XU MINGMEI AVOIDED THE MOON-NESTING (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14xuminglanmadearuckusatthexueju1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - XU MINGLAN MADE A RUCKUS AT THE XUEJU (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15xuminglancausedahugeruckusinthexuejupartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - XU MINGLAN CAUSED A HUGE RUCKUS IN THE XUEJU (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16afirstclassgirlisilliterate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - A FIRST-CLASS GIRL IS ILLITERATE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17agirloffirstclassisilliteratepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - A GIRL OF FIRST CLASS IS ILLITERATE (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18littlegardenencounterwithxutiandi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - LITTLE GARDEN ENCOUNTER WITH XU TIANDI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19peachesaremorethanjustaricebucket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - PEACHES ARE MORE THAN JUST A RICE BUCKET")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20menfromthepalace1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - MEN FROM THE PALACE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21menfromthepalacepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - MEN FROM THE PALACE (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22twosmallandnoguesses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - TWO SMALL AND NO GUESSES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23seniorservantliureturnedtothepalacetoreport",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - SENIOR SERVANT LIU RETURNED TO THE PALACE TO REPORT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24accompanyingreadingmustgotothepalace1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - ACCOMPANYING READING MUST GO TO THE PALACE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25accompanyingreadingmustgotothepalacemedium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - ACCOMPANYING READING MUST GO TO THE PALACE (MEDIUM)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26accompanyingthereadingneedstogotothepalacepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - ACCOMPANYING THE READING NEEDS TO GO TO THE PALACE (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27previouschapternextchapter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - < < PREVIOUS CHAPTER | NEXT CHAPTER > >")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28littlepartnerinthepalacemedium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - LITTLE PARTNER IN THE PALACE (MEDIUM)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29littlepartnerinthepalacepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - LITTLE PARTNER IN THE PALACE (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30lifeinthepalaceparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - LIFE IN THE PALACE (PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31lifeinthepalacemedium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - LIFE IN THE PALACE (MEDIUM)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32lifeinthepalacepartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - LIFE IN THE PALACE (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33eldestprincessaskedaboutvulgarity1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - ELDEST PRINCESS ASKED ABOUT VULGARITY (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34eldestprincessvenerablemedium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - ELDEST PRINCESS VENERABLE (MEDIUM)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35eldestprincessaskedaboutvulgaritypartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - ELDEST PRINCESS ASKED ABOUT VULGARITY (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36xumingweireturnedhome1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - XU MINGWEI RETURNED HOME (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37xumingweireturnedhomec",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - XU MINGWEI RETURNED HOME (C)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38xumingweireturnedhome2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - XU MINGWEI RETURNED HOME (2).")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39tigersbuttisuntouchable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - TIGER'S BUTT IS UNTOUCHABLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40moonnestinghotcauldron1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - MOON-NESTING HOT CAULDRON (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41moonnestinghotcauldronpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - MOON-NESTING HOT CAULDRON (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42xuminglantookoffherclothes1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - XU MINGLAN TOOK OFF HER CLOTHES (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43xuminglantookoffherclothesbottom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - XU MINGLAN TOOK OFF HER CLOTHES (BOTTOM)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44passengerfufamily1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - PASSENGER FU FAMILY (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45guesttravelerfufamilychina",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - GUEST TRAVELER FU FAMILY (CHINA)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46passengerfufamilypartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - PASSENGER FU FAMILY (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47fenghuatingbanquet1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - FENG HUA TING BANQUET (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48fenghuatingbanquet2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - FENG HUA TING BANQUET (2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49onthepaintingoffenghuatingparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - ON THE PAINTING OF FENG HUA TING (PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50onthepaintingoffenghuapavilionpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - ON THE PAINTING OF FENGHUA PAVILION (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51thegapbetweenthehomecomingsisters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - THE GAP BETWEEN THE HOMECOMING SISTERS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52mygoodbrotherisseekingthegiftofalargesumofmoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - MY GOOD BROTHER IS SEEKING THE GIFT OF A LARGE SUM OF MONEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53recklessminlaninvitation1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - RECKLESS MINLAN INVITATION (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54recklessminlaninvitationpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - RECKLESS MINLAN INVITATION (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55suspicionnannyaskingformedicine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - SUSPICION NANNY ASKING FOR MEDICINE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56embarrassedtsuentsuentsugeismyguest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - EMBARRASSED, TSUEN TSUEN TSU-GE IS MY GUEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57asyouwish1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - AS YOU WISH (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58asyouwishpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - AS YOU WISH (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59boldprincessescapepalace1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - BOLD PRINCESS ESCAPE PALACE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60boldprincessescapepalace2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - BOLD PRINCESS ESCAPE PALACE (2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61establishingtherulesandregulationsformingweisservantsandservants1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - ESTABLISHING THE RULES AND REGULATIONS FOR MINGWEI'S SERVANTS AND SERVANTS (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter62rulesmingweixunservantbelow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - RULES MINGWEI XUN SERVANT (BELOW)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63harddayherrevengeforhisbrother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - HARD DAY HER REVENGE FOR HIS BROTHER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64discerningcausefromminweisknowledge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - DISCERNING CAUSE FROM MINWEI'S KNOWLEDGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65reunionofmotherandmotherparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - REUNION OF MOTHER AND MOTHER (PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66reunionofmotherandmotherpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - REUNION OF MOTHER AND MOTHER (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67coincidentallywemeetagainatshoushan1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - COINCIDENTALLY, WE MEET AGAIN AT SHOUSHAN (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68coincidentallyreunitedwithshoushanchina",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - COINCIDENTALLY REUNITED WITH SHOUSHAN (CHINA)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69coincidentallywemeetagainatshoushanpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - COINCIDENTALLY, WE MEET AGAIN AT SHOUSHAN (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70houlanwasworriedaboutthemarriage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - HOULAN WAS WORRIED ABOUT THE MARRIAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71heshengchenguesthouseyang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - HE SHENGCHEN GUEST HOUSE YANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72helangoddaughterconscience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - HELAN GODDAUGHTER CONSCIENCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73idiotbetrothedtomarriage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - IDIOT BETROTHED TO MARRIAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74xumingzhusintentiontomarry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - XU MINGZHU'S INTENTION TO MARRY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75flowerboardpoemsofzhuduoparti",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - FLOWERBOARD POEMS OF ZHUDUO (PART I)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76flowerboardpoemsbyzhuzhuduopartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - FLOWERBOARD POEMS BY ZHU ZHUDUO (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77plottingagainstwangsmarriageproposal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - PLOTTING AGAINST WANG'S MARRIAGE PROPOSAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78agoodmisterwritesaguestletter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - A GOOD MISTER WRITES A GUEST LETTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79mingmeisheartwasfilledwithjoywhenshesawhercousin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - MING-MEI'S HEART WAS FILLED WITH JOY WHEN SHE SAW HER COUSIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80treatthenewguestasagiftfrommingwei",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - TREAT THE NEW GUEST AS A GIFT FROM MINGWEI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81coincidentallyhehadschemedforfuhengsinvitation1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - COINCIDENTALLY, HE HAD SCHEMED FOR FU HENG'S INVITATION (1).")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82coincidentallyhehadschemedforfuhengsinvitationnext",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - COINCIDENTALLY, HE HAD SCHEMED FOR FU HENG'S INVITATION (NEXT).")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83adultsfrommenarchetomingwei",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - ADULTS FROM MENARCHE TO MINGWEI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84goodplanladywangtotakeaconcubine1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - GOOD PLAN: LADY WANG TO TAKE A CONCUBINE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85goodplanladywangwantsaconcubine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - GOOD PLAN: LADY WANG WANTS A CONCUBINE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86meticulousqingmeicausingtrouble",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - METICULOUS QING MEI CAUSING TROUBLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87lilithtomingweispromise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - LILITH TO-MING-WEI'S PROMISE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88finallythequeendied",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - FINALLY, THE QUEEN DIED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89differentiatingbetweenyanmingweiandhisgovernment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - DIFFERENTIATING BETWEEN YAN MINGWEI AND HIS GOVERNMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90goodminweiasamessenger1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - GOOD MINWEI AS A MESSENGER (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91goodminweiasamessengerc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - GOOD MINWEI AS A MESSENGER (C)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92goodminweiasamessengerpartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - GOOD MINWEI AS A MESSENGER (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93thechaosxufuassignment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - THE CHAOS XU FU ASSIGNMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94gathertogethertomakepeace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - GATHER TOGETHER TO MAKE PEACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95escapeandlove1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - ESCAPE AND LOVE (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96escapeandlongevityrunforfriendspartii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - ESCAPE AND LONGEVITY RUN FOR FRIENDS (PART II)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter971thestoryoftheloserandtheloser1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - [1] THE STORY OF THE LOSER AND THE LOSER (1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98luochangshengandhismother2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - LUO CHANGSHENG AND HIS MOTHER (2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99speakingofwherejinxicamefrom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - SPEAKING OF WHERE JIN XI CAME FROM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100myricarubra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - MYRICA RUBRA")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0